import { render, staticRenderFns } from "./SummaryPizzaChart.vue?vue&type=template&id=591a15c5&scoped=true"
import script from "./SummaryPizzaChart.vue?vue&type=script&lang=js"
export * from "./SummaryPizzaChart.vue?vue&type=script&lang=js"
import style0 from "./SummaryPizzaChart.vue?vue&type=style&index=0&id=591a15c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591a15c5",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard});
